import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';
import { getLocaleRouteUrl } from '@/routes/routes/helpers/helpers';

import links from './links.json';

import { ArrowLeft } from '../../../Iconography';

import { item, link } from '../HeaderMenuNav/styles.module.css';
import styles from './styles.module.css';

// TODO: Webpack throws an error when using compose between these styles and HeaderMenuNav styles,
// perhaps some kind of circular dependency or specificity problem? Works with HMR, but not first build.
const linkStyle = `${link} ${styles.link}`;

/**
 * Categories Nav component.
 */
class CategoriesNav extends PureComponent {
  handleClickOutside = () => {
    const { onClickBack, visible } = this.props;
    if (visible) {
      onClickBack();
    }
  };

  render() {
    const {
      onMouseLeave,
      onClickBack,
      onLinkClick,
      visible,
      locale,
      narrow,
    } = this.props;

    return (
      <div
        className={visible ? styles.visibleContainer : styles.container}
        onMouseLeave={onMouseLeave}
      >
        <div className={styles.drawer}>
          <ul
            className={[styles.list, narrow ? styles.narrowStyle : ''].join(
              ' ',
            )}
            style={{
              /* Link height * number of links to form three columns */
              maxHeight: `calc(44px * ${Math.ceil(links.length / 3)})`,
            }}
          >
            <li className={`${item} ${styles.backLink}`}>
              <Link className={linkStyle} onClick={onClickBack}>
                <ArrowLeft className={styles.arrowLeft} />
                {'All Sports'}
              </Link>
            </li>
            {links.map((l) => (
              <li key={l.route} className={item}>
                <a
                  className={linkStyle}
                  onClick={onLinkClick}
                  href={getLocaleRouteUrl(l.route, locale)}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

CategoriesNav.propTypes = {
  locale: PropTypes.string.isRequired,
  onMouseLeave: PropTypes.func,
  onClickBack: PropTypes.func,
  onLinkClick: PropTypes.func,
  visible: PropTypes.bool,
};

CategoriesNav.defaultProps = {
  onMouseLeave: () => {},
  onClickBack: () => {},
  onLinkClick: () => {},
  visible: false,
  locale: undefined,
  hasUserCookie: false,
};

export default CategoriesNav;
